<template>
    <ul class="screen-box">
        <li>
            <div class="type-box">
                <i class="el-icon-wind-power"></i>
                <span>领域</span>
            </div>

            <div class="checked-box">
                <el-checkbox-group
                v-model="industry"
                @change="checkIndustry()">
                    <el-checkbox label="零售电商"></el-checkbox>
                    <el-checkbox label="服务电商"></el-checkbox>
                    <el-checkbox label="跨境电商"></el-checkbox>
                    <el-checkbox label="产业电商"></el-checkbox>
                    <el-checkbox label="在线教育"></el-checkbox>
                    <el-checkbox label="物流科技"></el-checkbox>
                </el-checkbox-group>
            </div>
        </li>

        <li>
            <div class="type-box">
                <i class="el-icon-bangzhu"></i>
                <span>类型</span>
            </div>

            <div class="checked-box">
                <el-checkbox-group
                v-model="type"
                @change="checkType()">
                    <el-checkbox label="上市公司"></el-checkbox>
                    <el-checkbox label="独角兽"></el-checkbox>
                    <el-checkbox label="投融资"></el-checkbox>
                    <el-checkbox label="投诉"></el-checkbox>
                    <el-checkbox label="法律"></el-checkbox>
                    <el-checkbox label="APP月活"></el-checkbox>
                    <el-checkbox label="评测"></el-checkbox>
                    <el-checkbox label="市场数据"></el-checkbox>
                    <el-checkbox label="AI报告"></el-checkbox>

                </el-checkbox-group>
            </div>
        </li>

        <li>
            <div class="type-box">
                <i class="el-icon-time"></i>
                <span>年份</span>
            </div>

            <div class="checked-box">
                <el-checkbox-group
                v-model="year"
                @change="checkYear()">
					<el-checkbox label="2025"></el-checkbox>
                    <el-checkbox label="2024"></el-checkbox>
                    <el-checkbox label="2023"></el-checkbox>
                    <el-checkbox label="2022"></el-checkbox>
                    <el-checkbox label="2021"></el-checkbox>
                    <el-checkbox label="2020"></el-checkbox>
                    <el-checkbox label="2019"></el-checkbox>
                    <el-checkbox label="2018"></el-checkbox>
                    <el-checkbox label="2017"></el-checkbox>
                    <el-checkbox label="2016"></el-checkbox>
                    <el-checkbox label="2015"></el-checkbox>
                    <el-checkbox label="2014"></el-checkbox>
                    <el-checkbox label="2013"></el-checkbox>
                    <el-checkbox label="2012"></el-checkbox>
                </el-checkbox-group>
            </div>
        </li>
    </ul>
</template>

<script>
import { eventBus } from '../main'

export default {
    name: 'Screen',
    data() {
        return {
            industry: [],
            type: [],
            year: [],
        }
    },
    methods: {
        checkIndustry() {
            this.getShow()

            eventBus.$emit('checkIndustry', this.industry)
            // console.log(this.industry);
        },
        checkType(val) {
            console.log(val,this.type);
            eventBus.$emit('checkType', this.type)
            // console.log(this.checkType);
            this.getShow()
        },
        checkYear() {
            eventBus.$emit('checkYear', this.year)
            // console.log(this.checkYear);
            this.getShow()
        },
        getShow() {
            this.$emit('show', false)
        }
    }
}
</script>

<style>
.screen-box {
    max-width: 1200px;
    background: #fff;
    padding: 20px;
    margin: 20px auto;
}

.screen-box li {
    display: flex;
    border-top: 1px solid #ccc;
}

.screen-box li:last-child {
    border-bottom: 1px solid #ccc;
}

.type-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    background: #e2ecff;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.type-box span {
    font-weight: 700;
    letter-spacing: 2px;
    margin-left: 10px;
}

.checked-box {
    flex: 1;
    display: flex;
    align-items: center;
    border-right: 1px solid #ccc;
    padding: 10px 15px;
}

@media(max-width: 1200px) {
    .screen-box {
        margin: 10px auto;
    }

    .screen-box,
    .checked-box {
        padding: 10px;
    }

    .screen-box li {
        display: inherit;
    }

    .type-box {
        width: 100%;
        line-height: 30px;
        border-bottom: 1px solid #ccc;
    }

    .checked-box {
        border-left: 1px solid #ccc;
    }

    .screen-box .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
    }

    .screen-box .el-checkbox {
        flex: 0 0 25%;
        margin-right: 0;
    }

    .screen-box .el-checkbox__label {
        padding-left: 5px;
        line-height: 24px;
    }
}
</style>
